import styled, { StyledComponent } from '@se-admin/falcon';
import { skeletonAnimationStyles } from '../../../common/utils/loadingSkeletons.styles';
import { SMALL_SALE_IMAGE_RATIO_PERCENTAGE } from '../SaleCard.styles';

export const AspectRatioWrapper: StyledComponent<'div', {}, {}> = styled.div`
  height: 0;
  width: 100%;
  position: relative;
  padding-bottom: ${SMALL_SALE_IMAGE_RATIO_PERCENTAGE}%;
  & > * {
    position: absolute;
  }
`;

const SKELETON_BUTTON_MARGIN_TOP: number = 110;
const SKELETON_BUTTON_HEIGHT: number = 46;
const SKELETON_BUTTON_WIDTH: number = 201;

export const ButtonSkeleton: StyledComponent<'div', {}, {}> = styled.div`
  ${skeletonAnimationStyles}

  margin-top: ${SKELETON_BUTTON_MARGIN_TOP}px;
  height: ${SKELETON_BUTTON_HEIGHT}px;
  width: ${SKELETON_BUTTON_WIDTH}px;
  align-self: flex-end;
  text-align: right;
  float: right;
`;
